import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import ImageBanner from '../../../assets/png/kids_fiesta.png';
import Robotin from '../../../assets/png/robotin.png';
import Robotina from '../../../assets/png/robotina.png';
import LogoBanner from '../../../assets/png/LOGO_fondo.png';
/* import Logo from '../../../assets/png/LOGO_fondo.png'; */
import Rocket from '../../../assets/png/rocket_kids_club.png';
import './BannerPerfil.scss';

const BannerPerfil = () => {
    return (
        <div className='container_banner_perfil' id='HomeLugar'>
            <Container>
             <Row>
              <Col md={3} sm={3} xl={3} xs={3}>
                <img src={Robotin} alt="" />
              </Col> 
              <Col md={6} sm={6} xl={6} xs={3}>
                  <img src={LogoBanner} alt="" />
              </Col> 
              <Col md={3} sm={3} xl={3} xs={3}>
                  <img src={Robotina} alt="" />
              </Col>   
                 {/* <Col md={6} sm={12} xl={6} className='information'>
                 <h1>Los mejores eventos solo en kids club</h1>
                 <img src={Rocket} alt="" />
                 <p>¡Celebra tu cumpleaños, juega y diviértete a lo grande!</p>
                 </Col>
                 <Col md={6} sm={0} xl={6} className='imagen_banner'>
                  <img src={ImageBanner} alt="" />
                 </Col> */}
             </Row>
            </Container>  
        </div>
    )
}

export default BannerPerfil;